/**
 * 能力值
 */
export type AbilityValue = {
    /**
     * 攻击，保存当前实例的攻击状态。
     */
    攻击: number;
    /**
     * 防御，保存当前实例的防御状态。
     */
    防御: number;
    /**
     * 特攻，保存当前实例的特攻状态。
     */
    特攻: number;
    /**
     * 特防，保存当前实例的特防状态。
     */
    特防: number;
    /**
     * 速度，保存当前实例的速度状态。
     */
    速度: number;
    /**
     * 体力，保存当前实例的体力状态。
     */
    体力: number;
    /**
     * pAtk，保存当前实例的pAtk状态。
     */
    pAtk?: number;
    /**
     * pDef，保存当前实例的pDef状态。
     */
    pDef?: number;
    /**
     * mAtk，保存当前实例的mAtk状态。
     */
    mAtk?: number;
    /**
     * mDef，保存当前实例的mDef状态。
     */
    mDef?: number;
    /**
     * speed，保存当前实例的speed状态。
     */
    speed?: number;
    /**
     * hp，保存当前实例的hp状态。
     */
    hp?: number;
};

/**
 * normalizeAbilityValue：执行对应的领域操作。
 * @param value 待处理的值
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function normalizeAbilityValue(value: Partial<AbilityValue>): AbilityValue {
    /**
     * source，供本模块相关规则使用。
     */
    const source = value as Record<string, number | undefined>;
    return {
        攻击: source.攻击 ?? source.pAtk ?? 0,
        防御: source.防御 ?? source.pDef ?? 0,
        特攻: source.特攻 ?? source.mAtk ?? 0,
        特防: source.特防 ?? source.mDef ?? 0,
        速度: source.速度 ?? source.speed ?? 0,
        体力: source.体力 ?? source.hp ?? 0,
    };
}